import { Component, Input } from '@angular/core';

import { FormControlChildAbstract } from '~/component/form/abstracts/control-child.abstract';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-form-dropdown-trigger',
  templateUrl: './trigger.component.html',
  styleUrls: ['./trigger.component.scss'],
})
export class FormDropdownTriggerComponent extends FormControlChildAbstract<void> {
  @Input() public isOpen = false;
  @Input() public label = '';
  @Input() public triggerId: string;

  public get ariaExpanded(): true | null {
    return this.isOpen ? true : null;
  }

  public get iconName(): VtmnPlayIconTypeEnum {
    return this.isOpen
      ? VtmnPlayIconTypeEnum.ChevronUp
      : VtmnPlayIconTypeEnum.ChevronDown;
  }

  /**
   * $event.detail === 0 => keydown.enter
   * $event.detail === 1 => simple click
   * $event.detail === 2 => double click
   */
  public stopPropagation($event: MouseEvent): void {
    if ($event.detail === 0) {
      // It's a keydown.enter event, not a click!
      $event.stopPropagation();
    }
  }
}
